import { render, staticRenderFns } from "./StepColorPicker.vue?vue&type=template&id=0e407af7&scoped=true&"
import script from "./StepColorPicker.vue?vue&type=script&lang=js&"
export * from "./StepColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./StepColorPicker.vue?vue&type=style&index=0&id=0e407af7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e407af7",
  null
  
)

export default component.exports